module.exports = __webpack_public_path__ + "img/8a6b656.jpg";